import Thankspage from '../../views/Thankspage';
import { connect } from 'react-redux';
import { actions } from '../../../state/auth';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickLogoffHandler: value => {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(actions.logout());
      // console.log(value);
      //dispatch(push(`/${locale}/logoff`));
    },

    clickFAQHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/faqpage`));
    }
  };
};

const ThankspageComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Thankspage);

export default ThankspageComponent;



// WEBPACK FOOTER //
// ./src/components/container/Thankspage/index.js